import { useCallback, useRef, useState } from "react";

// Undo stack for the slab layout: snapshots of areas + layout on the quote.
// Rapid changes (drags) within `coalesceMs` collapse into a single step.
export const useUndoHistory = (q, setQ, coalesceMs = 500, max = 40) => {
  const stack = useRef([]);
  const lastAt = useRef(0);
  const [count, setCount] = useState(0);

  const remember = useCallback(() => {
    if (!q) return;
    const now = Date.now();
    if (now - lastAt.current < coalesceMs && stack.current.length) {
      lastAt.current = now;
      return;
    }
    lastAt.current = now;
    stack.current = [...stack.current.slice(-(max - 1)), { areas: q.areas, layout: q.layout }];
    setCount(stack.current.length);
  }, [q, coalesceMs, max]);

  const undo = useCallback(() => {
    const snap = stack.current.pop();
    setCount(stack.current.length);
    lastAt.current = 0;
    if (snap) setQ((cur) => ({ ...cur, areas: snap.areas, layout: snap.layout }));
    return !!snap;
  }, [setQ]);

  return { remember, undo, canUndo: count > 0, undoCount: count };
};
